
import { Table, TableBody, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { NotificationSettingRow } from "./NotificationSettingRow";
import { type NotificationSetting } from "@/hooks/useNotificationSettings";

interface NotificationSettingsTableProps {
  settings: NotificationSetting[];
}

export const NotificationSettingsTable = ({ settings }: NotificationSettingsTableProps) => {
  return (
    <div className="overflow-x-auto">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="min-w-[120px]">حالة العميل</TableHead>
            <TableHead className="w-[80px]">تفعيل</TableHead>
            <TableHead className="w-[100px]">إشعار المنشئ</TableHead>
            <TableHead className="w-[100px]">إشعار المبيعات</TableHead>
            <TableHead className="w-[100px]">إشعار الخدمة</TableHead>
            <TableHead className="w-[120px]">تأخير (دقائق)</TableHead>
            <TableHead className="min-w-[300px]">قالب الرسالة</TableHead>
            <TableHead className="min-w-[200px]">قنوات الإرسال</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {settings.map((setting) => (
            <NotificationSettingRow key={setting.id} setting={setting} />
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
